// Module
var code = "<div layout-fill layout=\"column\" layout-align=\"center stretch\">\r\n    <md-content flex layout=\"column\" class=\"mn-top-padding\">\r\n        <mn-certificate-item mn-item=\"::vm.certificate\" mn-unique></mn-certificate-item>\r\n    </md-content>\r\n</div>\r\n";
// Exports
module.exports = code;